export default "__VITE_ASSET__0410d56b__"